import { FC } from 'react';

const ContactPage: FC = () => {
    return (
        <>
            <hr />
            <h1>ContactPage</h1>
            <hr />
        </>
    );
};

export default ContactPage;
